module.exports = __webpack_public_path__ + "static/media/calendar.855a3d39.svg";